import { EuiAvatar, EuiFlexGroup, EuiFlexItem, EuiLink } from "@elastic/eui";
import { GitLabUser } from "src/questionnaires";
import gravatar from "gravatar";

export const GitLabUserAvatar = ({
  user,
}: {
  user: GitLabUser;
}): JSX.Element => {
  return (
    <EuiFlexGroup direction="column">
      <EuiFlexItem>
        <EuiAvatar
          name={user.name}
          imageUrl={
            gravatar.url(user.public_email, {
              s: "32",
              d: "identicon",
              r: "pg",
            }) ||
            gravatar.url(user.name, {
              s: "32",
              d: "identicon",
              r: "pg",
            })
          }
          size="s"
        />
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiLink href={user.web_url} target="_blank">
          {user.username}
        </EuiLink>
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
